import { useTranslation } from "react-i18next";

const features = [
  { icon: "ri-grid-line", tKey: "f1t", dKey: "f1d" },
  { icon: "ri-search-eye-line", tKey: "f2t", dKey: "f2d" },
  { icon: "ri-truck-line", tKey: "f3t", dKey: "f3d" },
  { icon: "ri-user-heart-line", tKey: "f4t", dKey: "f4d" },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t("why.title")}
          </h2>
          <p className="mt-3 text-foreground-600">{t("why.subtitle")}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((f, i) => (
            <div
              key={f.tKey}
              className="rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${
                  i === 1
                    ? "bg-accent-100 text-accent-600"
                    : "bg-primary-100 text-primary-600"
                }`}
              >
                <i className={`${f.icon} w-6 h-6 flex items-center justify-center`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {t(`why.${f.tKey}`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {t(`why.${f.dKey}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}